export default{
    getProfile: state => state.user,
    verifyEmail: state => state.verifyEmail,
    userClub: state => state.userClub,
    isProfileLoaded: state => !!state.user.name,
}
